import React, { useState, useEffect } from 'react';
import Header from "./Header"

function PokerHands( data ) {

  const hands = [
    {
      title : 'Royal Flush',
      description : 'A Royal Flush is the highest possible hand in poker, consisting of the Ten, Jack, Queen, King, Ace, all of the same suit. This unbeatable hand is the pinnacle of poker hands.',
      imgSource : 'images/hands/royalFlush.png'
    },
    {
      title : 'Straight Flush',
      description : 'A Straight Flush is five consecutive cards of the same suit, such as 6-7-8-9-10 of hearts. It is only beaten by a higher straight flush or a royal flush.',
      imgSource : 'images/hands/straightFlush.png'
    },
    {
      title : 'Four of a Kind',
      description : 'Four of a Kind, also known as quads, consists of four cards of the same rank, like four 10s. This hand is only beaten by a straight flush or higher.',
      imgSource : 'images/hands/fourOfAKind.png'
    },
    {
      title : 'Full House',
      description : 'A Full House is a combination of three of a kind and a pair, such as two 9s and three Qs. It ranks above a flush and below four of a kind.',
      imgSource : 'images/hands/fullHouse.png'
    },
    {
      title : 'Flush',
      description : 'A Flush consists of five cards of the same suit, not in sequence, like A-10-8-6-5 of hearts. It ranks above a straight and below a full house.',
      imgSource : 'images/hands/flush.png'
    },
    {
      title : 'Straight',
      description : 'A Straight is five consecutive cards of different suits, such as 7-8-9-10-J. An Ace can be high or low, but not both in the same hand.',
      imgSource : 'images/hands/straight.png'
    },
    {
      title : 'Three of a Kind',
      description : 'Three of a Kind consists of three cards of the same rank, such as three 7s, with two other unrelated cards. It ranks above two pair and below a straight.',
      imgSource : 'images/hands/threeOfAKind.png'
    },
    {
      title : 'Two Pair',
      description : 'Two Pair consists of two cards of one rank and two cards of another rank, plus one unrelated card. It ranks above one pair and below three of a kind.',
      imgSource : 'images/hands/twoPair.png'
    },
    {
      title : 'Pair',
      description : 'A Pair consists of two cards of the same rank, such as two 8s, with three other unrelated cards. It ranks above a high card and below two pair.',
      imgSource : 'images/hands/pair.png'
    },
    {
      title : 'High Card',
      description : 'High Card is a hand that does not fit any other category. The highest card in the hand determines its value. It is the weakest hand in poker.',
      imgSource : 'images/hands/highCard.png'
    },
  ]

  const desktopHand = hands.map( ( hand, index ) => {
    return (
      <div className='handsTableItem' key={ index }>
        <div className='handsTableItemContentWrapper'>
          <div className='handsTableItemIndex'>{ index + 1 }</div>
          <div className='handsTableItemCards'>
            <img className='handsTableItemCardsImage' src={ hand.imgSource }></img>
          </div>
          <div className='handsTableItemInfo'>
            <h4>{ hand.title }</h4>
            <div className='handsTableItemDescription'>
              <p>{ hand.description }</p>
            </div>
          </div>
        </div>
        <div className='handsTableItemDevider' ></div>
      </div>
    )
  })

  const mobileHand = hands.map( ( hand, index ) => {
    return (
      <div className='handsTableItem' key={ index }>
        <div className='handsTableItemContentWrapper'>

          <div className='handsTableItemCards'>
            <img className='handsTableItemCardsImage' src={ hand.imgSource }></img>
          </div>
          
          <div className='handsTableItemInfo'>
            <div className='handsTableItemIndex'><h2>{ index + 1 }</h2></div>
            <h4>{ hand.title }</h4>
          </div>

          <div className='handsTableItemDescription'>
              <p>{ hand.description }</p>
            </div>
        </div>
        <div className='handsTableItemDevider' ></div>
      </div>
    )
  })

  return (
    <div className="gameTypesMainHolder">
      <Header headerContext='pokerHands'
      user={ data.user }
      logout={ data.logout }
      toggleGetChips={ data.toggleGetChips }
      width = { data.width }
      showSiteMenu = { data.showSiteMenu }
      toggleSiteMenu = { data.toggleSiteMenu }/>
      <div className='handsTableHolder'>
        <h2 className='pokerHandsTitle'>Poker Hands From Highest to Lowest</h2>
        <div className='handsTable'>
          { data.width && data.width > 1000 ? desktopHand : mobileHand }
        </div>
      </div>
    </div>
  )
}

export default PokerHands;